module.exports = __webpack_public_path__ + "static/media/Walk.1c9263b8.svg";